import React, {Component} from 'react';
import {ErrorMessage, Field, Form, Formik} from "formik";
import {Redirect} from "react-router";
import {withTranslation} from 'react-i18next';
import Header from "../Parts/Header";
import SubHeader from "../Parts/SubHeader";
import {toast} from "react-toastify";

class IncomeFamily extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                income: '',

                amount_cl: '',
                amount_mortgage: '',
                amount_other: '',
            },
            isLoading: false,
            skip_spouse_consent: false,
            has_liabilities: false,
            knows_about_future_financial_changes: false,
            step_count: 3,
            current_step: 2,

            redirectToNextStep: false,
        };

        this.formSubmit = this.formSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.handleLiabilityChange = this.handleLiabilityChange.bind(this);
    }

    handleOptionChange(changeEvent) {
        this.setState({knows_about_future_financial_changes: changeEvent.target.value === 'yes'});
        if (changeEvent.target.value === 'yes') {
            document.querySelector(`#income`)?.focus();
        }
    }

    handleLiabilityChange(changeEvent) {
        this.setState({has_liabilities: changeEvent.target.checked})
    }

    renderForm(props) {
        return (
            <Form className="form form-layout mt-5">
                <div className="container form-layout__2-col justify-content-start">

                    <div className="form-group w-100">
                        <label className="form-label"
                               htmlFor="income">{this.props.t('forms.monthly_income_family')}</label>
                        <Field type="number" name="income" id="income"
                               className={'form-control col-md-6 mx-2' + (props.errors.income && props.touched.income ? ' is-invalid' : '')}/>
                        <ErrorMessage name="income" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="col-12 mt-3">
                        <div className="mb-2 text-muted">{this.props.t('forms.family_do_you_know')}</div>
                        <div className="d-flex">
                            <div className="form-group mr-4">
                                <div className="custom-control custom-radio">
                                    <input type="radio"
                                           id="radiobuttonExample1"
                                           className="custom-control-input"
                                           value="yes"
                                           disabled={this.state.isLoading}
                                           checked={this.state.knows_about_future_financial_changes}
                                           onChange={this.handleOptionChange}
                                    />
                                    <label className="custom-control-label"
                                           htmlFor="radiobuttonExample1">{this.props.t('forms.yes')}</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="custom-control custom-radio">
                                    <input type="radio" id="radiobuttonExample2"
                                           className="custom-control-input"
                                           value="no"
                                           disabled={this.state.isLoading}
                                           checked={!this.state.knows_about_future_financial_changes}
                                           onChange={this.handleOptionChange}
                                    />
                                    <label className="custom-control-label"
                                           htmlFor="radiobuttonExample2">{this.props.t('forms.no')}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.knows_about_future_financial_changes &&
                    <div className="col-12  mb-4" style={{color: "#470A68"}}>
                        {this.props.t('forms.enter_expected_income')}
                    </div>
                    }

                    <div className="form-group col-12  mb-4">
                        <div className="custom-control custom-checkbox mt-3">
                            <input type="checkbox" className="custom-control-input" id="customCheck2"
                                   name="customCheck" checked={this.state.has_liabilities}
                                   disabled={this.state.isLoading}
                                   onChange={this.handleLiabilityChange}/>
                            <label className="custom-control-label" htmlFor="customCheck2">
                                {this.props.t('forms.has_liabilities')}
                                <i className="icons icon-question-circle" data-toggle="tooltip"
                                   data-placement="top" title={this.props.t('forms.liabilities_tooltip')}></i>
                            </label>
                        </div>
                    </div>

                    {this.state.has_liabilities &&
                    <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                        <div className="form-group">
                            <label htmlFor="amount_cl">{this.props.t('forms.your_credit_liabilities')}</label>
                            <div className="input-group">
                                <Field type="number" name="amount_cl" id="amount_cl"
                                       className={'form-control' + (props.errors.amount_cl && props.touched.amount_cl ? ' is-invalid' : '')}/>
                                <div className="input-group-append ">
                                    <div className="input-group-text bg-white border-left-0">
                                        {this.props.t('forms.eur_per_month')}
                                    </div>
                                </div>
                            </div>
                            <ErrorMessage name="amount_cl" component="div"
                                          className="invalid-feedback definitely-show"/>
                        </div>
                    </div>
                    }

                    {this.state.has_liabilities &&
                    <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                        <div className="form-group">
                            <label htmlFor="amount_mortgage">{this.props.t('forms.your_mortgage_liabilities')}</label>
                            <div className="input-group">
                                <Field type="number" name="amount_mortgage" id="amount_mortgage"
                                       className={'form-control' + (props.errors.amount_mortgage && props.touched.amount_mortgage ? ' is-invalid' : '')}/>
                                <div className="input-group-append ">
                                    <div className="input-group-text bg-white border-left-0">
                                        {this.props.t('forms.eur_per_month')}
                                    </div>
                                </div>
                            </div>
                            <ErrorMessage name="amount_mortgage" component="div"
                                          className="invalid-feedback  definitely-show"/>
                        </div>
                    </div>
                    }

                    {this.state.has_liabilities ? (
                            <div className="col-12 col-lg-4 col-md-6 liabilities-input">
                                <div className="form-group">
                                    <label htmlFor="amount_other">{this.props.t('forms.your_other_liabilities')}</label>
                                    <div className="input-group">
                                        <Field type="number" name="amount_other" id="amount_other"
                                               className={'form-control' + (props.errors.amount_other && props.touched.amount_other ? ' is-invalid' : '')}/>
                                        <div className="input-group-append ">
                                            <div className="input-group-text bg-white border-left-0">
                                                {this.props.t('forms.eur_per_month')}
                                            </div>
                                        </div>
                                    </div>
                                    <ErrorMessage name="amount_other" component="div"
                                                  className="invalid-feedback  definitely-show"/>
                                </div>
                            </div>)
                        : ''}

                    {this.state.has_liabilities &&
                    <p className="col-12 text-muted">{this.props.t('forms.liabilities_explanation')}</p>
                    }

                    <div className="form-group col-12 d-flex justify-content-center mt-3">
                        <button type="submit" className="btn btn-primary btn-lg"
                                disabled={props.isSubmitting || this.state.isLoading}>
                            {this.props.t('forms.next')}
                        </button>
                    </div>
                </div>
            </Form>);
    }

    formSubmit(values, actions) {

        values.knownFamIncomeChanges = this.state.knows_about_future_financial_changes;

        this.setState({isLoading: true});
        axios.post('/api/process/' + this.props.application_token + '/income_family', values)
            .then(
                data => {
                    this.setState({isLoading: false});
                    actions.setSubmitting(false);
                    if (data.data.status === 'success') {
                        this.setState({skip_spouse_consent: data.data.skip_spouse_consent});
                        this.setState({redirectToNextStep: true});
                    }
                },
                error => {
                    this.setState({isLoading: false});
                    let response_data = error.response.data;
                    toast.error(response_data.message);
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                    actions.setStatus({message: response_data.message})
                }
            )
            .catch((a, b, c) => {
                this.setState({isLoading: false});
                console.log(a, b, c);
            });
    }

    render() {
        if (this.state.redirectToNextStep) {
            if (this.state.skip_spouse_consent){
                return <Redirect push={true} to={this.props.suggestion.process_step_urls.choose_terms}/>
            } else {
                return <Redirect push={true} to={'/' + this.props.application_token + '/process/send_spouse_link'}/>
            }
        }

        return (
            <div>
                <Header title={this.props.t('step.registration')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('substep.income_family')}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step}/>
                        <div className="row">
                            <Formik
                                initialValues={this.state.data}
                                onSubmit={this.formSubmit}
                                render={this.renderForm}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(IncomeFamily);
